import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from 'axios';
import { isArray } from 'lodash';
import qs from 'qs';
import { getTripartiteCooperationProductStatusList } from '../../localeConstants';
import { PartnerType } from '../../shared/generated';
import { getTripartiteCooperationMemberRoleList } from '../../tripartiteCooperation';
import { filterOutRequestExtraParameters, handleApiRequestSuccessData, handleRequestError } from '../../utils/request';
import { formatCommonDateStr } from '../../utils/time';
import { api } from '../index';
var baseURL = process.env['NX_JOVE_API'];
export var apiQueryTripartiteCooperationList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var _res$data, res;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return api.get("/brokers?".concat(qs.stringify(filterOutRequestExtraParameters(payload), {
              arrayFormat: 'repeat'
            })));

          case 5:
            res = _context.sent;
            _context.next = 12;
            break;

          case 8:
            payload.hideErrToast = true;
            _context.next = 11;
            return api.get("/partners?".concat(qs.stringify(filterOutRequestExtraParameters(payload), {
              arrayFormat: 'repeat'
            })));

          case 11:
            res = _context.sent;

          case 12:
            if (isArray((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data.forEach(function (item) {
                item.value = item.id;
                item.label = item.name;
              });
            }

            return _context.abrupt("return", [res.data]);

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function apiQueryTripartiteCooperationList(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiCreateTripartiteCooperation = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return api.post('/brokers', filterOutRequestExtraParameters(payload));

          case 5:
            res = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.next = 10;
            return api.post('/partners', filterOutRequestExtraParameters(payload));

          case 10:
            res = _context2.sent;

          case 11:
            return _context2.abrupt("return", [res.data]);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 14]]);
  }));

  return function apiCreateTripartiteCooperation(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiDeleteTripartiteCooperation = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context3.next = 8;
              break;
            }

            _context3.next = 5;
            return api["delete"]("/brokers/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId));

          case 5:
            res = _context3.sent;
            _context3.next = 11;
            break;

          case 8:
            _context3.next = 10;
            return api["delete"]("/partners/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId));

          case 10:
            res = _context3.sent;

          case 11:
            return _context3.abrupt("return", [res.data || {}]);

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 14]]);
  }));

  return function apiDeleteTripartiteCooperation(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiUpdateTripartiteCooperationInfo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context4.next = 8;
              break;
            }

            _context4.next = 5;
            return api.patch("/brokers/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId), filterOutRequestExtraParameters(payload));

          case 5:
            res = _context4.sent;
            _context4.next = 11;
            break;

          case 8:
            _context4.next = 10;
            return api.patch("/partners/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId), filterOutRequestExtraParameters(payload));

          case 10:
            res = _context4.sent;

          case 11:
            return _context4.abrupt("return", [res.data]);

          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 17:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 14]]);
  }));

  return function apiUpdateTripartiteCooperationInfo(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiQueryTripartiteCooperationMemberList = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var _res$data2, res;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            payload['partner_id'] = payload === null || payload === void 0 ? void 0 : payload.tripartiteId;
            _context5.next = 4;
            return api.get("/partner_invitations?".concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 4:
            res = _context5.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data)) {
              res.data.data = res.data.data.map(function (item) {
                var _getTripartiteCoopera;

                item.roleText = (_getTripartiteCoopera = getTripartiteCooperationMemberRoleList().find(function (aItem) {
                  return aItem.value === item.role;
                })) === null || _getTripartiteCoopera === void 0 ? void 0 : _getTripartiteCoopera.label;
                return item;
              });
            }

            return _context5.abrupt("return", [res.data]);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0, payload));

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));

  return function apiQueryTripartiteCooperationMemberList(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiCreateTripartiteCooperationMember = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.post('/partner_invitations', filterOutRequestExtraParameters(payload));

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function apiCreateTripartiteCooperationMember(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiUpdateTripartiteCooperationMember = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
    var params, res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            params = _objectSpread({}, filterOutRequestExtraParameters(payload));
            delete params.partnerMemberId;
            delete params.token;
            _context7.next = 6;
            return api.patch("/partner_invitations/broker/".concat(payload === null || payload === void 0 ? void 0 : payload.partnerMemberId, "?token=").concat(payload.token), params);

          case 6:
            res = _context7.sent;
            handleApiRequestSuccessData(res);
            return _context7.abrupt("return", [res.data]);

          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0, payload));

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 11]]);
  }));

  return function apiUpdateTripartiteCooperationMember(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiDeleteTripartiteCooperationMember = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api["delete"]("/partner_invitations/".concat(payload === null || payload === void 0 ? void 0 : payload.memberId));

          case 3:
            res = _context8.sent;
            return _context8.abrupt("return", [res.data]);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", handleRequestError(_context8.t0, payload));

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));

  return function apiDeleteTripartiteCooperationMember(_x8) {
    return _ref8.apply(this, arguments);
  };
}();
export var apiGetTripartiteCooperationDetailInfo = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
    var _res, res, _res2, _res2$data;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context9.next = 8;
              break;
            }

            _context9.next = 5;
            return api.get("/brokers/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId));

          case 5:
            res = _context9.sent;
            _context9.next = 11;
            break;

          case 8:
            _context9.next = 10;
            return api.get("/partners/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId));

          case 10:
            res = _context9.sent;

          case 11:
            if ((_res = res) !== null && _res !== void 0 && _res.data) {
              // Partner
              res.data.referral_fee = Number(res.data.referral_fee || 0) * 100;
              res.data.isSubEntity = !!((_res2 = res) !== null && _res2 !== void 0 && (_res2$data = _res2.data) !== null && _res2$data !== void 0 && _res2$data.parent_id);
            }

            return _context9.abrupt("return", [res.data]);

          case 15:
            _context9.prev = 15;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", handleRequestError(_context9.t0, payload));

          case 18:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 15]]);
  }));

  return function apiGetTripartiteCooperationDetailInfo(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
export function apiQueryTripartiteCooperationProductListById(_x10) {
  return _apiQueryTripartiteCooperationProductListById.apply(this, arguments);
}

function _apiQueryTripartiteCooperationProductListById() {
  _apiQueryTripartiteCooperationProductListById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payload) {
    var _res$data4, res;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return api.get("/partner/promotions/get_all_by_partner_id/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId, "?").concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 3:
            res = _context16.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data)) {
              res.data.data = res.data.data.map(function (item) {
                var _getTripartiteCoopera2;

                item.startDateText = formatCommonDateStr(item.start_date);
                item.endDateText = !!item.end_date ? formatCommonDateStr(item.end_date) : 'Ongoing';
                item.statusText = (_getTripartiteCoopera2 = getTripartiteCooperationProductStatusList().find(function (aItem) {
                  return aItem.value === item.status;
                })) === null || _getTripartiteCoopera2 === void 0 ? void 0 : _getTripartiteCoopera2.label;
                item.value = item.id;
                item.label = item.name;
                item.regions = isArray(item.regions) ? item.regions : item.region ? [item.region] : [];
                item.countries = (item.countries || []).map(function (aItem) {
                  return _objectSpread(_objectSpread({}, aItem), {}, {
                    value: aItem.id,
                    label: aItem.name
                  });
                });
                return item;
              });
            }

            return _context16.abrupt("return", [res.data]);

          case 8:
            _context16.prev = 8;
            _context16.t0 = _context16["catch"](0);
            return _context16.abrupt("return", handleRequestError(_context16.t0, payload));

          case 11:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 8]]);
  }));
  return _apiQueryTripartiteCooperationProductListById.apply(this, arguments);
}

export function apiCreateTripartiteCooperationProduct(_x11) {
  return _apiCreateTripartiteCooperationProduct.apply(this, arguments);
}

function _apiCreateTripartiteCooperationProduct() {
  _apiCreateTripartiteCooperationProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.GENERAL)) {
              _context17.next = 8;
              break;
            }

            _context17.next = 5;
            return api.post('/partner/promotions', filterOutRequestExtraParameters(payload));

          case 5:
            res = _context17.sent;
            _context17.next = 12;
            break;

          case 8:
            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context17.next = 12;
              break;
            }

            _context17.next = 11;
            return api.post('/partner/promotions', filterOutRequestExtraParameters(payload));

          case 11:
            res = _context17.sent;

          case 12:
            return _context17.abrupt("return", [res.data]);

          case 15:
            _context17.prev = 15;
            _context17.t0 = _context17["catch"](0);
            return _context17.abrupt("return", handleRequestError(_context17.t0, payload));

          case 18:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 15]]);
  }));
  return _apiCreateTripartiteCooperationProduct.apply(this, arguments);
}

export function apiUpdateTripartiteCooperationProduct(_x12) {
  return _apiUpdateTripartiteCooperationProduct.apply(this, arguments);
}

function _apiUpdateTripartiteCooperationProduct() {
  _apiUpdateTripartiteCooperationProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return api.patch("/partner/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.productId), filterOutRequestExtraParameters(payload));

          case 3:
            res = _context18.sent;
            return _context18.abrupt("return", [res.data]);

          case 7:
            _context18.prev = 7;
            _context18.t0 = _context18["catch"](0);
            return _context18.abrupt("return", handleRequestError(_context18.t0, payload));

          case 10:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 7]]);
  }));
  return _apiUpdateTripartiteCooperationProduct.apply(this, arguments);
}

export function apiDeleteTripartiteCooperationProduct(_x13) {
  return _apiDeleteTripartiteCooperationProduct.apply(this, arguments);
}

function _apiDeleteTripartiteCooperationProduct() {
  _apiDeleteTripartiteCooperationProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return api["delete"]("/partner/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.productId));

          case 3:
            res = _context19.sent;
            return _context19.abrupt("return", [res.data || {}]);

          case 7:
            _context19.prev = 7;
            _context19.t0 = _context19["catch"](0);
            return _context19.abrupt("return", handleRequestError(_context19.t0, payload));

          case 10:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 7]]);
  }));
  return _apiDeleteTripartiteCooperationProduct.apply(this, arguments);
}

export function apiGetTripartiteCooperationProductDetailInfo(_x14) {
  return _apiGetTripartiteCooperationProductDetailInfo.apply(this, arguments);
}

function _apiGetTripartiteCooperationProductDetailInfo() {
  _apiGetTripartiteCooperationProductDetailInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;
            _context20.next = 3;
            return api.get("/partner/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.productId));

          case 3:
            res = _context20.sent;

            if (res !== null && res !== void 0 && res.data) {
              res.data.discount = Number(res.data.discount || 0) * 100; // Partner

              res.data.partner_referral_fee = Number(res.data.partner_referral_fee || 0) * 100;
            }

            return _context20.abrupt("return", [res.data || {}]);

          case 8:
            _context20.prev = 8;
            _context20.t0 = _context20["catch"](0);
            return _context20.abrupt("return", handleRequestError(_context20.t0, payload));

          case 11:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[0, 8]]);
  }));
  return _apiGetTripartiteCooperationProductDetailInfo.apply(this, arguments);
}

export function apiGetTripartiteCooperationProductDetailInfoWithNoAuth(_x15) {
  return _apiGetTripartiteCooperationProductDetailInfoWithNoAuth.apply(this, arguments);
}

function _apiGetTripartiteCooperationProductDetailInfoWithNoAuth() {
  _apiGetTripartiteCooperationProductDetailInfoWithNoAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;
            _context21.next = 3;
            return api.get("/partner/promotions/no_auth/".concat(payload === null || payload === void 0 ? void 0 : payload.productId));

          case 3:
            res = _context21.sent;
            return _context21.abrupt("return", [res.data || {}]);

          case 7:
            _context21.prev = 7;
            _context21.t0 = _context21["catch"](0);
            return _context21.abrupt("return", handleRequestError(_context21.t0, payload));

          case 10:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[0, 7]]);
  }));
  return _apiGetTripartiteCooperationProductDetailInfoWithNoAuth.apply(this, arguments);
}

export function apiGetTripartiteCooperationInfoBySlug(_x16) {
  return _apiGetTripartiteCooperationInfoBySlug.apply(this, arguments);
}

function _apiGetTripartiteCooperationInfoBySlug() {
  _apiGetTripartiteCooperationInfoBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(payload) {
    var _res3, res, _res$data5;

    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context22.next = 8;
              break;
            }

            _context22.next = 5;
            return api.get("/brokers/get_by_slug/".concat(payload === null || payload === void 0 ? void 0 : payload.slug));

          case 5:
            res = _context22.sent;
            _context22.next = 11;
            break;

          case 8:
            _context22.next = 10;
            return api.get("/partners/get_by_slug/".concat(payload === null || payload === void 0 ? void 0 : payload.slug));

          case 10:
            res = _context22.sent;

          case 11:
            if ((_res3 = res) !== null && _res3 !== void 0 && _res3.data) {
              res.data.isSubEntity = !!((_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.parent_id);
            }

            return _context22.abrupt("return", [res.data || {}]);

          case 15:
            _context22.prev = 15;
            _context22.t0 = _context22["catch"](0);
            return _context22.abrupt("return", handleRequestError(_context22.t0, payload));

          case 18:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, null, [[0, 15]]);
  }));
  return _apiGetTripartiteCooperationInfoBySlug.apply(this, arguments);
}

export var apiGetTripartiteCooperationDetailInfoWithNoAuth = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return api.get("/brokers/no_auth/".concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId));

          case 3:
            res = _context10.sent;
            return _context10.abrupt("return", [res.data]);

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", handleRequestError(_context10.t0, payload));

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 7]]);
  }));

  return function apiGetTripartiteCooperationDetailInfoWithNoAuth(_x17) {
    return _ref10.apply(this, arguments);
  };
}();
export var apiGetTripartiteCooperationDetailInfoWithNoAuthAndDirectlyAxios = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return axios.get("".concat(baseURL, "/brokers/no_auth/").concat(payload === null || payload === void 0 ? void 0 : payload.tripartiteId));

          case 3:
            res = _context11.sent;
            return _context11.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 7:
            _context11.prev = 7;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", handleRequestError(_context11.t0, payload));

          case 10:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 7]]);
  }));

  return function apiGetTripartiteCooperationDetailInfoWithNoAuthAndDirectlyAxios(_x18) {
    return _ref11.apply(this, arguments);
  };
}();
export var apiCheckTripartiteCooperationSlugAvailable = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            res = {
              data: null
            };

            if (!((payload === null || payload === void 0 ? void 0 : payload.sourceType) === PartnerType.BROKER)) {
              _context12.next = 8;
              break;
            }

            _context12.next = 5;
            return api.post("/brokers/check-slug-exist?".concat(qs.stringify(filterOutRequestExtraParameters(payload))), filterOutRequestExtraParameters(payload));

          case 5:
            res = _context12.sent;
            _context12.next = 11;
            break;

          case 8:
            _context12.next = 10;
            return api.post("/brokers/check-slug-exist?".concat(qs.stringify(filterOutRequestExtraParameters(payload))), filterOutRequestExtraParameters(payload));

          case 10:
            res = _context12.sent;

          case 11:
            handleApiRequestSuccessData(res);
            return _context12.abrupt("return", [res.data]);

          case 15:
            _context12.prev = 15;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", handleRequestError(_context12.t0, payload));

          case 18:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 15]]);
  }));

  return function apiCheckTripartiteCooperationSlugAvailable(_x19) {
    return _ref12.apply(this, arguments);
  };
}();
export var apiGetProductBrokerEntityInfoWithNoAuthAndDirectlyAxios = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return axios.get("".concat(baseURL, "/brokers/broker-entity/").concat(payload.brokerId, "/all"));

          case 3:
            res = _context13.sent;
            return _context13.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            return _context13.abrupt("return", handleRequestError(_context13.t0, payload));

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));

  return function apiGetProductBrokerEntityInfoWithNoAuthAndDirectlyAxios(_x20) {
    return _ref13.apply(this, arguments);
  };
}();
export var apiQuerySubTripartiteCooperationList = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payload) {
    var _res$data3, temp, res;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            temp = _objectSpread({}, payload);
            delete temp.parentId;
            _context14.next = 5;
            return api.get("/brokers/".concat(payload === null || payload === void 0 ? void 0 : payload.parentId, "/children?").concat(qs.stringify(filterOutRequestExtraParameters(temp), {
              arrayFormat: 'repeat'
            })));

          case 5:
            res = _context14.sent;

            if (isArray((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data)) {
              res.data.data.forEach(function (item) {
                item.value = item.id;
                item.label = item.name;
                item.isSubEntity = !!item.parent_id;
                item.allProductsText = (item.promotions || []).map(function (item) {
                  return item.name;
                }).join(', ');
              });
            }

            return _context14.abrupt("return", [res.data]);

          case 10:
            _context14.prev = 10;
            _context14.t0 = _context14["catch"](0);
            return _context14.abrupt("return", handleRequestError(_context14.t0, payload));

          case 13:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 10]]);
  }));

  return function apiQuerySubTripartiteCooperationList(_x21) {
    return _ref14.apply(this, arguments);
  };
}();
export var apiCreateSubTripartiteCooperation = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return api.post("/brokers/".concat(payload === null || payload === void 0 ? void 0 : payload.parent_broker_id, "/child"), filterOutRequestExtraParameters(payload));

          case 3:
            res = _context15.sent;
            return _context15.abrupt("return", [res.data]);

          case 7:
            _context15.prev = 7;
            _context15.t0 = _context15["catch"](0);
            return _context15.abrupt("return", handleRequestError(_context15.t0, payload));

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 7]]);
  }));

  return function apiCreateSubTripartiteCooperation(_x22) {
    return _ref15.apply(this, arguments);
  };
}();